import { ReactNode } from 'react';
import { useLocation } from 'wouter';
import { useBranding } from '@/shared/contexts/BrandingContext';

interface RouteProtectionProps {
  children: ReactNode;
}

// Routes that should be hidden from Greenshield B2C users (excluding Business Hub routes)
const B2B_ROUTES = [
  '/free-trial',
  '/book-demo',
  '/case-studies'
];

// Business Hub routes - accessible to authenticated users regardless of brand
const BUSINESS_HUB_ROUTES = [
  '/admin',
  '/backend-admin',
  '/pricing-admin', 
  '/analytics-dashboard',
  '/command-center',
  '/admin-command-center',
  '/cms-admin',
  '/workflow-admin',
  '/complexity-dashboard',
  '/sop-management',
  '/field-technician',
  '/customer-management',
  '/crm',
  '/sustainability-impact-tracker',
  '/iot-pest-sensors',
  '/sustainability-dashboard',
  '/smart-treatment-optimizer',
  '/predictive-calendar',
  '/marketing-strategy',
  '/high-roi-campaigns',
  '/seasonal-trends-dashboard',
  '/pest-trends-dashboard',
  '/eco-warrior-badges',
  '/access-control',
  '/customer-import',
  '/technician-assessment',
  '/feature-ideas',
  '/assessment-schedule',
  '/ai-intelligence',
  '/ai-features-hub',
  '/community-knowledge-sharing'
];

export default function RouteProtection({ children }: RouteProtectionProps) {
  const { isGreenshield } = useBranding();
  const [location, setLocation] = useLocation();

  // Only block specific B2B marketing routes for Greenshield users
  // Business Hub routes are accessible to all authenticated users
  if (isGreenshield && B2B_ROUTES.some(route => location.startsWith(route))) {
    // Redirect to home page
    setLocation('/');
    return null;
  }

  return <>{children}</>;
}